module.exports = ".center {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 30px; }\n  .center .container {\n    display: block;\n    text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/students/no-student-selected/no-student-selected.component.scss
// module id = ./src/app/students/no-student-selected/no-student-selected.component.scss
// module chunks = main